module.exports = __webpack_public_path__ + "static/img/m_global_slogan_word@3x.676d9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_slogan_word@3x.png
// module id = IicF
// module chunks = 1